export default "__VITE_ASSET__BXRN0vLC__"